import * as React from "react";
const SvgStop = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6 6H18V18H6V6Z", fill: "#474749" }));
export default SvgStop;
